import { Alert, Button } from 'antd';
import { Mail } from 'lucide-react';
import { SecurityMethodCard } from '../../../components/SecurityMethodCard';
import { TurnOffWithPassword } from '../../../components/TurnOffWithPassword';

interface EmailOtpStatusCardProps {
  email: string;
  enabled: boolean;
  error: string | null;
  submitting: boolean;
  onEnable: () => void;
  onDisable: (password: string) => Promise<boolean>;
}

/** The at-rest view of email codes. Turning them on sends a code first, to prove the inbox works. */
export function EmailOtpStatusCard({ email, enabled, error, submitting, onEnable, onDisable }: EmailOtpStatusCardProps) {
  return (
    <SecurityMethodCard
      icon={Mail}
      title="Email codes"
      isEnabled={enabled}
      description={enabled ? `A code sent to ${email} can finish signing in.` : `Get a 6-digit code at ${email} each time you sign in.`}
    >
      {!enabled && (
        <>
          {error && <Alert className="mt-5" type="error" title={error} showIcon />}
          <Button className="mt-5" type="primary" onClick={onEnable} loading={submitting}>
            Turn on
          </Button>
        </>
      )}
      {enabled && <TurnOffWithPassword error={error} submitting={submitting} onConfirm={onDisable} />}
    </SecurityMethodCard>
  );
}
